<template>
  <div style="display: flex;flex-direction: column;width:100%;">
    <div v-if="title"
         style="width: 100%;margin: 10px 0;display: flex;flex-direction: row;align-items: center;justify-content: center;">
      <div :style="{
        borderRadius: '5px',width:'60px',height:'1px',backgroundColor:hcf.getMainColor()+'5a'
      }"/>
      <div :style="{
        borderRadius:'10px',width:'5px',height:'5px',border: `${hcf.getMainColor()+'5a'} 2px solid`,
      }"/>
      <div :style="hcf.getTextStyle({
        color:'main',marginRight: 5,marginLeft: 5,fontWeight:'bold',addSize:1
      })">{{ title }}
      </div>
      <div :style="{
        borderRadius:'10px',width:'5px',height:'5px',border: `${hcf.getMainColor()+'5a'} 2px solid`,
      }"/>
      <div :style="{
        borderRadius: '5px',width:'60px',height:'1px',backgroundColor:hcf.getMainColor()+'5a'
      }"/>
    </div>
    <div :style="{
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0 13px',
    alignItems: 'center',
    columnGap:'13px',
  }">
      <div v-for="(eachItem,index) in eachTemplate['ItemList']" :key="eachItem['Id']" :style="{
          marginBottom:eachRowCount>1?(HNewGameUIConfig.newGameUIType === 4&&title?'0':'13px'):'7px',
        }">

        <div @click="clickCheckMore(eachItem)"
             v-if="((eachTemplate['HaveMore']??false) && eachTemplate['ItemList'].length-1 === index)" :style="{
          width:eachImgWidth+'px',
          border:hcf.getMainColor()+' 1px dashed',
          height:eachImgWidth+10+'px',
          borderRadius:'10px',
          display:'flex',
          alignItems:'center',
          justifyContent:'center',
          color:hcf.getMainColor(),
          backgroundColor:hcf.getMainColor()+'22',
          fontSize:'14px',
        }">
          查看更多
        </div>

        <EachGameItem v-if="!((eachTemplate['HaveMore']??false) && eachTemplate['ItemList'].length-1 === index)"
                      :isHaveTitle="title"
                      :itemInfo="eachItem"
                      :eachRowCount="eachRowCount"
                      :eachImgWidth="eachImgWidth"
                      :favoriteCallback="favoriteCallback"
                      :isFromHome="true"
        />
      </div>
    </div>
  </div>
</template>


<script setup>
  import {hcf, log} from "@/components/utils/HComFunctions.js";
  import EachGameItem from "@/components/pages/EachGameItem.vue";
  import {useClickModal} from "@/hooks/useClickModal.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const props = defineProps(["eachTemplate", "favoriteCallback"]);
  //一行几个元素
  let eachRowCount = ref(3);
  let title = ref(props.eachTemplate["Title"]);
  switch (props.eachTemplate["TemplateType"]) {
    case 1:
      eachRowCount.value = 1;
      break;
    case 2:
      eachRowCount.value = 1;
      break;
    case 3:
      eachRowCount.value = 2;
      break;
    case 4:
    case 5:
    case 6:
    case 7:
      eachRowCount.value = 3;
      break;
    case 999:
      eachRowCount.value = 4;
      break;
    default:
      eachRowCount.value = 3;
      break;
  }
  let eachSpace = 13;
  // 图标宽用 clientWidth 兜底; 被 hsxs_h5 以 <iframe srcdoc> 内嵌时, 首帧嵌套视口可能偏大,
  // 故挂载后 + resize 时重算, 视口结算/翻页后图标自动修正(独立浏览器下取值本就正确, 重算为 no-op)。
  function calcEachImgWidth() {
    const vw = document.documentElement.clientWidth || window.innerWidth;
    return (vw - 76 - eachSpace * (eachRowCount.value + 1)) / eachRowCount.value;
  }
  const eachImgWidth = ref(calcEachImgWidth());
  function onViewportResize() {
    const w = calcEachImgWidth();
    if (w > 0 && w !== eachImgWidth.value) eachImgWidth.value = w;
  }
  onMounted(() => {
    onViewportResize();
    requestAnimationFrame(onViewportResize);
    setTimeout(onViewportResize, 300);
    window.addEventListener('resize', onViewportResize);
  });
  onUnmounted(() => {
    window.removeEventListener('resize', onViewportResize);
  });
  const clickModal = useClickModal();

  function clickCheckMore(itemInfo) {
    clickModal.onClick(itemInfo);
  }
</script>


<style scoped>
  ::v-deep(.van-grid-item__content) {
    line-height: normal !important; /* 设置为正常行高 */
  }

  ::v-deep(.van-grid-item__content--center) {
    line-height: normal !important; /* 设置为正常行高 */
  }

  ::v-deep(.van-grid-item__content) {
    padding: 0 !important;
  }
</style>
